import styled from 'styled-components';

export const Container = styled.section`
  .items {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
`;
